module.exports = __webpack_public_path__ + "img/clear-small-gray-icon.e5e3a524.svg";